export default "__VITE_ASSET__CGnkTaM1__"